document.querySelectorAll("#addNotifierButton").forEach(function (element) {
  element.addEventListener("click", function (event) {
    event.preventDefault()
    event.stopPropagation()
    document.querySelector("#addNotifier").classList.remove("hidden")

    function hideAddNotifier() {
      document.querySelector("#addNotifier").classList.add("hidden")
      document.querySelector("html").removeEventListener("click", hideAddNotifier)
    }

    document.querySelector("html").addEventListener("click", hideAddNotifier)
  })
})
